import * as React from "react";

import * as dates from "../../../reducers/changeTimePeriod";

export interface IDateHeadingProps {
  currentDate: Date;
  fromDate: Date;
  toDate: Date;
}

export const WeeklyListDateHeading = (props: IDateHeadingProps) => {

  const dateDesc = getDateDescription(props.fromDate, props.toDate);

  return (
    <div className="CAL-daysOfWeek" aria-hidden="true">
      <ul>
        <li>{dateDesc}</li>
      </ul>
    </div>
  );
};

const getDateDescription = (fromDate: Date, toDate: Date): string => {

  const fromDateMonthNumber = dates.getMonthNumber(fromDate);
  const toDateMonthNumber = dates.getMonthNumber(toDate);

  const fromDateYear = fromDate.getFullYear();
  const toDateYear = toDate.getFullYear();

  let dateDesc = "";

  if (fromDateMonthNumber === toDateMonthNumber && fromDateYear === toDateYear) {
    dateDesc = getDateDesc_InSameMonthAndSameYear(fromDate, toDate);
  } else if (fromDateMonthNumber !== toDateMonthNumber && fromDateYear === toDateYear) {
    dateDesc = getDateDesc_InDifferentMonthAndSameYear(fromDate, toDate);
  } else if (fromDateMonthNumber !== toDateMonthNumber && fromDateYear !== toDateYear) {
    dateDesc = getDateDesc_InDifferentMonthAndDifferentYear(fromDate, toDate);
  } else {
    dateDesc = dates.formatDaynameMonthYear(fromDate) + " - " + dates.formatDaynameMonthYear(toDate);
  }

  return dateDesc;
};

const getDateDesc_InSameMonthAndSameYear = (fromDate: Date, toDate: Date): string => {
  // Date formatted as '(Full month name) (start date day number)-(end date day number), (Year)'
  const monthName = dates.formatMonthName(fromDate);
  const fromDateDayNumber = dates.getDayOfMonth(fromDate).toString();
  const toDateDayNumber = dates.getDayOfMonth(toDate).toString();
  const theYear = fromDate.getFullYear().toString();

  return `${monthName} ${fromDateDayNumber} - ${toDateDayNumber}, ${theYear}`;
};

const getDateDesc_InDifferentMonthAndSameYear = (fromDate: Date, toDate: Date): string => {
  // Date formatted as '(Abbreviated month name of start date) (start date day number) - (Abbreviated month name of end date) (end date day number) (Year)'
  const fromMonthAbbrevName = dates.formatAbbreviatedMonthName(fromDate);
  const fromDateDayNumber = dates.getDayOfMonth(fromDate).toString();
  const toMonthAbbrevName = dates.formatAbbreviatedMonthName(toDate);
  const toDateDayNumber = dates.getDayOfMonth(toDate).toString();
  const theYear = fromDate.getFullYear().toString();

  return `${fromMonthAbbrevName} ${fromDateDayNumber} - ${toMonthAbbrevName} ${toDateDayNumber}, ${theYear}`;
};

const getDateDesc_InDifferentMonthAndDifferentYear = (fromDate: Date, toDate: Date): string => {
  // Date formatted as '(Abbreviated month name of start date) (start date day number) (Start Date year) - (Abbreviated month name of end date) (end date day number) (End date Year)'
  const fromMonthAbbrevName = dates.formatAbbreviatedMonthName(fromDate);
  const fromDateDayNumber = dates.getDayOfMonth(fromDate).toString();
  const fromYear = fromDate.getFullYear().toString();
  const toMonthAbbrevName = dates.formatAbbreviatedMonthName(toDate);
  const toDateDayNumber = dates.getDayOfMonth(toDate).toString();
  const toYear = toDate.getFullYear().toString();

  return `${fromMonthAbbrevName} ${fromDateDayNumber} ${fromYear} - ${toMonthAbbrevName} ${toDateDayNumber} ${toYear}`;
};
